import { createSelector } from "@reduxjs/toolkit";
import { selectVisibleFacets } from "./select-visible-facets";
import { selectInitialFacets } from "./select-initial-facets";

export const selectVisibleNumberFacetValue = (facetFieldName: string) =>
	createSelector(
		[selectInitialFacets, selectVisibleFacets],
		(initialFacets, visibleFacets) => {
			var numberFacetValue = visibleFacets[facetFieldName] as number;

			if (numberFacetValue === null || numberFacetValue === undefined) {
				return initialFacets[facetFieldName] as number;
			}

			return numberFacetValue;
		},
	);
